
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"110","height":"110","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.5 88.5l32-32L93 60l2.5 3v6L69 95.5l-4 .5-2.5-1.5-6-6zM42 14l5 1 9.5 9L24 56.5 14.5 46v-5.5L42 14z","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M38.794 16.109L16.108 38.795a6.875 6.875 0 000 9.723L61.48 93.89a6.875 6.875 0 009.723 0l22.686-22.686a6.875 6.875 0 000-9.723L48.517 16.11a6.875 6.875 0 00-9.723 0zM24.209 56.618l32.409-32.409m0 64.821l32.413-32.413M27.45 40.416l12.966-12.967m-10.624 80.25l11.458-9.158-11.458-9.176m11.458 9.177c-15.867 2.997-34.375-6.875-38.958-22.917M80.208 2.3L68.75 11.459l11.458 9.176M68.75 11.459c15.868-2.998 34.375 6.875 38.958 22.916","stroke":"#F2994A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    